import { Directive } from '@angular/core';

@Directive({
  selector: '[app-input-suffix]',
  host: { class: '!w-fit' },
})
export class InputSuffixDirective {}
